<template>
  <div class="wordcloud">
    <h2>Projecten die wij steunen</h2>

    <div class="words">
      <span>{{ $t("wordcloud.word1") }}</span>
      <span>{{ $t("wordcloud.word2") }}</span>
      <span>{{ $t("wordcloud.word3") }}</span>
      <span>{{ $t("wordcloud.word4") }}</span>
      <span>{{ $t("wordcloud.word5") }}</span>
      <span>{{ $t("wordcloud.word6") }}</span>
      <span>{{ $t("wordcloud.word7") }}</span>
    </div>
  </div>

  <!-- <footer>hoi</footer> -->
</template>

<!-- Script
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<script>
export default {
  name: "wordcloud",
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<!-- Style
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<style lang="scss">
#app .wordcloud {
  @include maxWidthCenter;
  padding-top: 80px;
  padding-bottom: 60px;

  h2 {
    margin-bottom: 20px;
  }

  .words {
    position: relative;
    min-height: 220px;
    // background-color: pink;

    @include min-large {
      font-size: 1.4em;
    }

    span {
      position: absolute;
      display: inline-block;
      color: $light-green;
      font-weight: 600;
      letter-spacing: 1.4px;

      animation: bringWordsToLife 4s linear infinite;
      animation-direction: alternate;
      transform-origin: center;
      // border: 2px solid pink;
    }

    span:nth-of-type(1) {
      top: 14%;
      left: 16%;
      font-size: 82%;
    }
    span:nth-of-type(2) {
      top: 20%;
      left: 70%;
      font-size: 100%;
      animation-delay: 2s;
    }
    span:nth-of-type(3) {
      top: 48%;
      left: 10%;
      font-size: 130%;
      animation-delay: 4s;
    }
    span:nth-of-type(4) {
      top: 44%;
      left: 44%;
      font-size: 78%;
      animation-delay: 6s;
    }
    span:nth-of-type(5) {
      top: 60%;
      left: 66%;
      font-size: 140%;
      animation-delay: 1s;
    }
    span:nth-of-type(6) {
      top: 80%;
      left: 20%;
      font-size: 100%;
      animation-delay: 6s;
    }
    span:nth-of-type(7) {
      top: 86%;
      left: 60%;
      font-size: 80%;
      animation-delay: 5s;

      @include min-large {
        top: 91%;
        left: 50%;
      }
    }
  }
}

@keyframes bringWordsToLife {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}
</style>
